module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "donate-layout"
  }, [_c('div', {
    staticClass: "earth-hour-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('div', {
    staticClass: "sign-img",
    style: ({
      'background-image': 'url(\'' + _vm.imageUrl + '\')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donate()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabel))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d522fa7e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=a9gwdhtvlz!./~/string-replace-webpack-plugin/loader.js?id=zp0damlfgbk!./src/components/earth-hour/EarthhourPopup.vue
// module id = 731
// module chunks = 0